var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    { staticClass: "text-xs-center" },
    [
      _c("v-progress-circular", {
        staticClass: "loader",
        attrs: { size: "35", indeterminate: "", color: "primary" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }